<template>
  <div v-show="isActive" class="popup-wrap popup-wallet fun-detailed" :class="{ active: isActive }">
    <div class="popup-box">
      <a class="popup-close" @click="hideWalletModal"><i class="fa-solid fa-xmark" /></a>

      <div class="form-popup popup-padding m-loginRegister-frame">
        <div class="reg-popupBox">
          <h4 class="register-title font-w-b text-align-L">
            {{ $t('Bao.personal_detail') }}
          </h4>

          <div class="pop-wallet-list">
            <ul class="crypto-list">
              <li
                v-for="wallet in filteredWalletInfo"
                :key="`wallet-item-${ wallet.currency }-${wallet.wallet_type}`"
                :data-value="wallet.currency"
                :class="{ 'active': app.selectedWallet && wallet.wallet_type === app.selectedWallet.wallet_type }"
                @click="selectWallet(wallet)"
              >
                <img
                  :key="`wallet-img-${ wallet.currency }-${wallet.wallet_type}`"
                  :src="getWalletImagePath(wallet)"
                  :alt="wallet.currency"
                >
                <div class="crypto-box">
                  <b class="currency">{{ wallet.name }}</b>
                  <p class="amounts">
                    {{ getWalletBalance(wallet) }}
                  </p>
                </div>
              </li>
            </ul>

            <div class="logged-in-frame user-dep">
              <div class="hr-line" />
              <ul class="user-dep-info">
                <li class=" fs-6 fw-700">
                  <div class="left-side">
                    {{ $t('Bao.available_withdrawal_amount') }}
                  </div>
                  <div class="t-highlight">
                    {{ availPrice }}
                  </div>
                </li>
                <li>
                  <div class="left-side">
                    {{ $t('Bao.deposit_limit') }}
                  </div>
                  <div class="right-side t-highlight">
                    {{ withdrawalLimit }}
                  </div>
                </li>
              </ul>
              <button class="btn btn-dep fs-14px" @click="$router.push('/deposit')">
                {{ $t('Bao.deposit') }}
              </button>
              <button class="btn btn-dep fs-14px" @click="$router.push('/withdrawal')">
                {{ $t('Bao.withdrawal') }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <i class="content-left dis_none" />
    </div>
  </div>
</template>

<script>
import { getWalletImagePath, getFilteredWalletInfo, getWalletBalance } from '@/utils/tool'
import { mapGetters } from 'vuex'

export default {
  name: 'PersonalWalletModal',
  props: {
    isActive: Boolean,
    availPrice: {
      type: String,
      default: () => ''
    },
    withdrawalLimit: {
      type: String,
      default: () => ('')
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['user', 'brandInfo', 'walletInfo', 'app']),
    filteredWalletInfo() {
      return getFilteredWalletInfo(this.walletInfo, this.brandInfo)
    }
  },
  methods: {
    hideWalletModal() {
      this.$emit('hideWalletModal')
    },
    getWalletImagePath,
    getWalletBalance,
    selectWallet(wallet) {
      this.$store.commit('SET_SELECTED_WALLET', wallet)
      this.hideWalletModal()
    }
  }
}
</script>
